



































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import logger from "@/configs/logger";
import { filter } from "lodash";

@Component
export default class SetDispositionMenu extends Vue {
  @Prop({ required: true }) setDisposition!: Function;
  @Prop({ required: true }) dispositions!: string[];
  @Prop({ required: true }) taskCreationSource!: string;
  @Prop() width!: string | number;
  selectedDisposition: number | null = null;
  searchDispositionText: string = "";
  filteredDispositons: string[] = [];
  dispositionItems: string[] = [];

  @Watch("searchDispositionText")
  onSearchDisposition(val: string) {
    const filtered = filter(this.dispositionItems, function(
      disposition: string
    ) {
      return disposition.toLowerCase().indexOf(val.toLowerCase()) >= 0;
    });

    this.filteredDispositons = filtered;

    if (val) {
      this.filteredDispositons = filtered;
    } else {
      this.filteredDispositons = this.dispositionItems;
    }

    this.selectedDisposition = null;
  }

  @Watch("selectedDisposition")
  onSelectedDispositionListChange(val: number) {
    if (this.searchDispositionText) {
      this.setDisposition(this.filteredDispositons[val]);
    } else {
      this.setDisposition(this.dispositionItems[val]);
    }
  }

  // to update
  @Watch("dispositions")
  onGetDispositions() {
    if (Array.isArray(this.dispositions) && this.dispositions.length) {
      this.filteredDispositons = this.dispositions;
      this.dispositionItems = this.dispositions;
    } else {
      return [];
    }
  }

  mounted() {
    if (Array.isArray(this.dispositions) && this.dispositions.length) {
      this.filteredDispositons = this.dispositions;
      this.dispositionItems = this.dispositions;
    } else {
      return [];
    }
  }
}
